import {
  timeFormat,
  getEntityTypeIcon,
  getCombineEntityType,
  getCombineImageEntityType,
} from '@/pages/home/pages/home/Explore/_config/common';
// @ts-ignore
import { history } from 'umi';
import { useEffect, useRef } from 'react';
import { IS_SEARCH_HOME, getWindowState, setWindowState } from '@/pages/home/utils/state';
import { IS_GLOBAL, IS_INTLGAME } from '@/pages/home/_config/config';
import { financeFormat } from '@/pages/home/utils/common';
import moment from 'moment';
import { DASHBOARD_SENSITIVE_GAME } from '@home/_config/constant';
import { ENTITY_TYPE_GP } from '@/pages/home/components/NavHeader/_config';

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SEARCH_PARAMS = {
  kw: '',
  unid: '',
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  type: 'all',
};

// 获取目前地栏搜索的参数
export const getSearchPageParams = () => ({ ...DEFAULT_SEARCH_PARAMS, ...history.location.query });

// 替换地址栏参数，且判断是否添加到历史记录
export const updateSearchPageUrl = (params: any, ifPush: undefined | boolean) => {
  const isSearchHome = getWindowState(IS_SEARCH_HOME);
  let linkType = 'replace';
  if (ifPush === undefined) {
    if (isSearchHome) {
      linkType = 'push';
      setWindowState(IS_SEARCH_HOME, false);
    }
  } else if (ifPush) {
    linkType = 'push';
  }
  (history as any)[linkType]({
    pathname: history.location.pathname,
    query: {
      ...params,
    },
  });
};

// 跳转到搜索页面
export const goToSearchPageUrl = (params: any) => {
  history.push({
    pathname: '/search',
    query: {
      ...params,
    },
  });
};

// 搜索release时间格式转换
export const getSearchRelease = (date: string) => timeFormat(date);

// B，M，K保留2位小数, 坐标轴的话不显示小数,所以加paseInt处理
export function mathFormat(data: any, showZero = true, min = 1000) {
  let unit = 'k';
  let value = Math.abs(data);
  if (showZero && !data) return 0;
  if (!data || isNaN(data) || Number(data) === 0) return '-';
  const isNegativeStr = data < 0 ? '-' : '';
  // 最外面的 parseFloat用于去除末尾无效的零
  if (value < 1000000 && value >= 1000) {
    unit = 'K';
    value = parseFloat((parseFloat(`${value}`) / 1000).toFixed(2));
  } else if (value >= 1000000 && value < 1000000000) {
    unit = 'M';
    value = parseFloat((parseFloat(`${value}`) / 1000000).toFixed(2));
  } else if (value >= 1000000000) {
    unit = 'B';
    value = parseFloat((parseFloat(`${value}`) / 1000000000).toFixed(2));
  } else if (value < min) {
    unit = '';
    value = parseInt(data);
  } else {
    unit = '';
    value = parseFloat(parseFloat(`${value}`).toFixed(2));
  }
  // Math.abs会去掉末尾的0，为保证数据格式统一，所以不用
  if (value < 0) value = -value;
  return isNegativeStr + value + unit;
}

// 获取新的releaseTime取值逻辑
export const getReleaseFormatValue = (item: any, isEn: boolean) => {
  const {
    is_special_release_time: isSpecialReleaseTime = false,
    release_time: releaseTime = '',
    release_time_cn: releaseTimeCn = '',
    release_time_en: releaseTimeEn = '',
  } = item || {};
  if (isSpecialReleaseTime) {
    return isEn ? releaseTimeEn : releaseTimeCn;
  }
  return getSearchRelease(releaseTime);
};

// 按照固定顺序进行顺序
const sortGameBtnByKey = (btnList: any) => {
  // 添加搜索结果跳转按钮显示顺序
  const GAME_BTN_SORT = ['dashboard', 'gpop', 'opinion', 'intelligence'];
  const sortedArray = [...btnList];
  sortedArray.sort((a, b) => {
    const valueA = a.sortKey;
    const valueB = b.sortKey;

    const indexA = GAME_BTN_SORT.indexOf(valueA);
    const indexB = GAME_BTN_SORT.indexOf(valueB);

    return indexA - indexB;
  });

  return sortedArray;
};

// 返回搜索结果游戏列表数据
export const getSearchResultCardList = (list: any, isEn: boolean) => {
  const cardList: any = [];
  if (Array.isArray(list)) {
    list?.map((item: any) => {
      const btnListTemp: any[] = [];
      if (item.dashboard !== 0) {
        const tipText = () => {
          if (IS_GLOBAL) return 'dbh_search_dashboard_tip_global';
          // 部分游戏特殊处理
          if (DASHBOARD_SENSITIVE_GAME.includes(item.game_id))
            return 'dbh_search_dashboard_tip_sensitive';
          if (IS_INTLGAME) return 'dbh_search_dashboard_tip_intlgame';
          return 'dbh_search_dashboard_tip_woa';
        };
        const objTemp = {
          titleKey: 'dbh_dashboard',
          sortKey: 'dashboard',
          tipText: tipText(),
          icon: 'merit',
          isDisabled: item.dashboard === 1,
        };
        btnListTemp.push(objTemp);
      }
      if (item.gpop !== 0) {
        const objTemp = {
          titleKey: 'dbh_gpop',
          sortKey: 'gpop',
          tipText: 'dbh_search_g_pop_tip',
          icon: 'search-gp-btn',
          isDisabled: item.gpop === 1,
        };
        btnListTemp.push(objTemp);
      }
      if (item.opinion !== 0) {
        const objTemp = {
          titleKey: 'dbh_opinion',
          sortKey: 'opinion',
          tipText: 'dbh_search_opinion_tip',
          icon: 'public',
          isDisabled: item.opinion === 1,
        };
        btnListTemp.push(objTemp);
      }
      if (item.entity_type !== ENTITY_TYPE_GP) {
        const objTemp = {
          titleKey: 'dbh_intelligence',
          sortKey: 'intelligence',
          tipText: 'dbh_search_intelligent_tip',
          icon: 'intelligence',
          isDisabled: false,
        };
        btnListTemp.push(objTemp);
      }

      const listObjTemp = {
        gameId: item.game_id,
        type: getCombineEntityType(item.entity_type, item),
        imageType: getCombineImageEntityType(item.entity_type, item),
        img: item.cover,
        title: item.entity_name,
        release: getReleaseFormatValue(item, isEn),
        publisher: item.publisher,
        btnList: sortGameBtnByKey(btnListTemp), // 对拥有的跳转按钮进行排序
        icon: getEntityTypeIcon(getCombineEntityType(item.entity_type, item)),
        itemObj: item,
        entityType: item?.entity_type || '',
        gPopInfo: item?.gpop_info || {},
        opinionInfo: item?.opinion_info || {},
        consoleId: item?.console_id || '',
        pcId: item?.pc_id || '',
      };
      cardList.push(listObjTemp);
    });
  }
  return cardList;
};

const metricMap: any = {
  dau: 'dbh_metric_dau',
  download: 'dbh_downloads',
  hoursWatched: 'dbh_metric_hourswatched',
  peackCCV: 'dbh_metric_peakccv',
  revenue: 'dbh_metric_revenue',
  mau: 'dbh_metric_mau',
  pcu: 'dbh_metric_pcu',
  gamalytic__pcu: 'dbh_metric_pcu',
  gamalytic__wishlists: 'dbh_metric_gamalytic_steam_daily_wishlist',
  gamalytic__wishlists_total: 'dbh_metric_gamalytic_steam_lifetime_wishlist',
  alinea__pcu: 'dbi_metric_alinea_steam_pcu',
  alinea__wishlists: 'dbi_metric_alinea_steam_daily_wishlist',
  alinea__wishlists_total: 'dbi_metric_alinea_steam_lifetime_wishlist',
  'steam top sellers': 'dbh_metric_steamtopsellers',
  digitalARPPU: 'dbh_metric_digitalarppu_usonly',
  digitalRevenue: 'dbh_metric_digital_revenue',
  lifetime_player: 'dbh_metric_lifetime_player',
};

const metricMapCombine: any = {
  dau: 'dbh_metric_dau',
  download: 'dbh_downloads',
  hoursWatched: 'dbh_metric_hourswatched',
  peackCCV: 'dbh_metric_peakccv',
  revenue: 'dbh_metric_revenue',
  mau: 'dbh_metric_mau',
  pcu: 'dbh_metric_pcu',
  gamalytic__pcu: 'dbh_metric_pcu',
  gamalytic__wishlists: 'dbh_metric_gamalytic_steam_daily_wishlist',
  gamalytic__wishlists_total: 'dbh_metric_gamalytic_steam_lifetime_wishlist',
  alinea__pcu: 'dbi_metric_alinea_steam_pcu',
  alinea__wishlists: 'dbi_metric_alinea_steam_daily_wishlist',
  alinea__wishlists_total: 'dbi_metric_alinea_steam_lifetime_wishlist',
  'steam top sellers': 'dbh_metric_steamtopsellers_combine',
  digitalARPPU: 'dbh_metric_digitalarppu_usonly',
  digitalRevenue: 'dbh_metric_digital_revenue',
  units: 'dbh_metric_units_combine',
  gsd_digitalUnits: 'dbh_metric_gsd_combine',
  lifetime_player: 'dbh_metric_lifetime_player',
  wishlists_total: 'dbi_metric_lifetime_wishlist',
  wishlists: 'dbi_metric_daily_wishlist',
  rank: 'dbi__metric_store_rank_top_seller',
  airtime: 'Airtime',
};

// 首页搜索经分卡片指标对应中英翻译key
const metricMapDashBoard: any = {
  DAU: 'dbh_metric_dau',
  download: 'dbh_downloads',
  'Revenue($)': 'dbh_metric_revenue_dol',
  New: 'dbh_metric_New',
  'D2(T-1)': 'dbh_metric_d2_t1',
  'ARPU($)': 'dbh_metric_arpu_dol',
  'Payer%': 'dbh_metric_payer_pre',
};

const getDashboardMetrics = (metrics: string) => {
  if (metrics === 'Revenue' || metrics === 'ARPU') {
    return `${metrics}($)`;
  }
  return metrics;
};

const iconMap: any = {
  ogdb: 'databrain',
  appannie: 'appnnie',
  stream: 'hatchet',
  newzoo: 'newzoo',
  steamcharts: 'steamblack',
  steam: 'steamblack',
  gamalytic: 'gamalytic',
  alinea: 'alinea',
  mscience: 'mscience',
  npd: 'npd',
  gsd: 'gsd',
  sensortower: 'sensortower',
  vginsights: 'vginsights',
  'steam top wish lists': 'steamblack',
};

const mobileTabMap: any = {
  dau: 'activeusers',
  download: 'downloads',
  revenue: 'revenue',
  hoursWatched: 'hoursWatched',
  peackCCV: 'peackCCV',
};

const mobileTabMapOld: any = {
  dau: 'activeusers',
  download: 'downloads',
  revenue: 'revenue',
  hoursWatched: 'hoursWatched',
  peackCCV: 'peackCCV',
};

const pcTabMap: any = {
  mau: 'mau',
  pcu: 'pcu',
  alinea__pcu: 'pcu',
  digitalARPPU: 'digitalRevenue',
  digitalRevenue: 'digitalRevenue',
  hoursWatched: 'hoursWatched',
  peackCCV: 'peackCCV',
  revenue: 'physicalRevenue',
  lifetime_player: 'lifetime_player',
  wishlists: 'wishlists',
  wishlists_total: 'wishlists_total',
  alinea__wishlists: 'wishlists',
  alinea__wishlists_total: 'wishlists_total',
  rank: 'storeRank',
  airtime: 'airtime',
};

const pcTabMapOld: any = {
  mau: 'mau',
  pcu: 'pcu',
  digitalARPPU: 'digitalrevenue',
  digitalRevenue: 'digitalrevenue',
  hoursWatched: 'hoursWatched',
  peackCCV: 'peackCCV',
  revenue: 'physicalrevenue',
  lifetime_player: 'lifetime_player',
};

const consoleTabMap: any = {
  mau: 'mau',
  digitalARPPU: 'digitalRevenue',
  digitalRevenue: 'digitalRevenue',
  hoursWatched: 'hoursWatched',
  peackCCV: 'peackCCV',
  revenue: 'physicalRevenue',
  lifetime_player: 'lifetime_player',
};

const combineTabMap: any = {
  pcu: 'pcu',
  alinea__pcu: 'pcu',
  'steam top sellers': 'storeRank',
  digitalRevenue: 'digitalRevenue',
  units: 'units',
  gsd_digitalUnits: 'gsd_digitalUnits',
  wishlists: 'wishlists',
  wishlists_total: 'wishlists_total',
  alinea__wishlists: 'wishlists',
  alinea__wishlists_total: 'wishlists_total',
  hoursWatched: 'hoursWatched',
  peackCCV: 'peackCCV',
  airtime: 'airtime',
  rank: 'storeRank',
};

const consoleTabMapOld: any = {
  mau: 'mau',
  digitalARPPU: 'revenue',
  digitalRevenue: 'revenue',
  hoursWatched: 'hoursWatched',
  revenue: 'physicalrevenue',
  lifetime_player: 'lifetime_player',
};

const getMetricValue = (data: any): string => {
  if (!data) return '-';
  let min = undefined; // 低于这个数，直接取整数
  let num = data.value || 0;
  let suffix = ''; // 后缀
  if (['D2(T-1)', 'Payer%'].includes(data.metrics_name)) {
    suffix = '%';
    min = 0;
    num = num * 100;
  } else if (['ARPU'].includes(data.metrics_name)) {
    min = 0;
  }
  const result = mathFormat(num, false, min);
  return result && result !== '-' ? result + suffix : '-';
};

const getGameStatTab = (metric: string, entity_type: string) => {
  switch (entity_type) {
    case 'mobile':
      return mobileTabMap[metric];
    case 'pc':
      return pcTabMap[metric];
    case 'console':
      return consoleTabMap[metric];
    case 'combine':
      return combineTabMap[metric];
  }
};

const getGameStatTabOld = (metric: string, entity_type: string) => {
  switch (entity_type) {
    case 'mobile':
      return mobileTabMapOld[metric];
    case 'pc':
      return pcTabMapOld[metric];
    case 'console':
      return consoleTabMapOld[metric];
  }
};

const dealRankValue = (rank: number | string) => {
  if (rank === 0 || rank === '' || rank === undefined || rank === 'undefined') {
    return '-';
  }

  const rankNumber = typeof rank === 'string' ? Number(rank) : rank;
  if (!rankNumber || Number.isNaN(rankNumber)) {
    return '-';
  }
  if (rankNumber >= 999) {
    return '#999+';
  }
  return `#${rankNumber}`;
};

const ifNotStoreData = (metric: string) => {
  switch (metric) {
    case 'appstore top free':
    case 'appstore top paid':
    case 'googleplay top free':
    case 'googleplay top paid':
    case 'steam top sellers':
    case 'epic top sellers':
      return false;
    default:
      return true;
  }
};

const combineData = (metric: string, entityType: string) => {
  if (entityType === 'combine') {
    switch (metric) {
      case 'steam top sellers':
        return true;
      default:
        return false;
    }
  } else {
    return false;
  }
};

const getIsRevenueMetric = (entityType: string, colItem: any) => {
  const MONTHMETRICMAP = {
    pc: ['digitalRevenue', 'digitalARPPU', 'mau'],
    console: ['digitalRevenue', 'revenue', 'digitalARPPU', 'mau', 'lifetime_player'],
    combine: ['digitalRevenue', 'units'],
  } as any;
  if (entityType !== 'mobile') {
    return MONTHMETRICMAP[entityType]?.includes(colItem?.metric);
  }
  return false;
};

// 获取搜索卡片指标对应时间
const getItemDate = (colItem: any, entityType: string) => {
  const dateValue = colItem?.date || colItem?.this_time || '';
  if (!dateValue) return '';
  if (colItem?.start_date && colItem?.metric === 'gsd_digitalUnits') {
    return `${colItem?.start_date}~${dateValue}`;
  }
  if (getIsRevenueMetric(entityType, colItem)) {
    return moment(dateValue)?.format('YYYY-MM');
  }
  return dateValue;
};

// 返回搜索结果游戏列表数据
export const turnCardInfoDataList = (
  isGetDashboard: boolean,
  dataDashboard: Array<any>,
  dataIntelligence: Array<any>,
  entityType: string,
) => {
  const intelligenceCardList: any = [];

  // 只展示6个，有商店排行榜的，组成数组放最后一个
  const arrayLength = isGetDashboard ? dataDashboard.length : dataIntelligence.length;
  const rowCount = Math.ceil(arrayLength / 2) > 3 ? 3 : Math.ceil(arrayLength / 2);

  for (let row = 0;row < rowCount;row++) {
    // 排列出非商店榜单数据卡片
    const colArray = [0, 1];
    colArray.forEach((item) => {
      const colCount = row * 2 + item;

      // 经分数据卡片
      if (isGetDashboard) {
        const colItem: any = dataDashboard[colCount];
        if (colItem) {
          const objTemp = {
            title: metricMapDashBoard[getDashboardMetrics(colItem?.metrics_name || '')],
            icon: '',
            num: getMetricValue(colItem) || '',
            text: '',
            goto: 'dashboard',
            date: getItemDate(colItem?.dod, entityType),
          };
          intelligenceCardList.push(objTemp);
        }
      } else {
        // 情报数据卡片
        const colItem: any = dataIntelligence[colCount];
        if (colItem) {
          if (ifNotStoreData(colItem?.metric) || combineData(colItem?.metric, entityType)) {
            const objTemp = {
              ...colItem,
              title:
                (entityType === 'combine'
                  ? metricMapCombine[colItem?.metric]
                  : metricMap[colItem?.metric]) || '',
              icon:
                colItem?.data_source === 'gamalytic' &&
                (colItem?.metric === 'gamalytic__pcu')
                  ? 'steamblack'
                  : iconMap[colItem?.data_source],
              num: financeFormat(colItem?.value, 2, false, '-'),
              text: dealRankValue(colItem?.rank),
              goto: getGameStatTab(colItem?.metric, entityType) || '',
              gotoOld: getGameStatTabOld(colItem?.metric, entityType) || '',
              date: getItemDate(colItem, entityType),
              rank:
                entityType === 'combine' && colItem?.metric === 'steam top sellers'
                  ? colItem?.value
                  : '',
              marketImg: getIsRevenueMetric(entityType, colItem) ? 'us' : '',
            };
            intelligenceCardList.push(objTemp);
          }
        }
      }
    });

    // 商店榜单数据卡片
    if (!isGetDashboard && row === 2) {
      if (entityType === 'mobile') {
        const appstoreFree = dataIntelligence.findIndex(
          (item: any) => item.metric === 'appstore top free',
        );
        const googleplayFree = dataIntelligence.findIndex(
          (item: any) => item.metric === 'googleplay top free',
        );
        const appstorePaid = dataIntelligence.findIndex(
          (item: any) => item.metric === 'appstore top paid',
        );
        const googleplayPaid = dataIntelligence.findIndex(
          (item: any) => item.metric === 'googleplay top paid',
        );
        let appleValue = '';
        let appleValueDate = '';
        if (appstoreFree !== -1) {
          appleValue = dataIntelligence[appstoreFree]?.value;
          appleValueDate = dataIntelligence[appstoreFree]?.date;
        } else if (appstorePaid !== -1) {
          appleValue = dataIntelligence[appstorePaid]?.value;
          appleValueDate = dataIntelligence[appstorePaid]?.date;
        }
        let googleValue = '';
        let googleValueDate = '';
        if (googleplayFree !== -1) {
          googleValue = dataIntelligence[googleplayFree]?.value;
          googleValueDate = dataIntelligence[googleplayFree]?.date;
        } else if (googleplayPaid !== -1) {
          googleValue = dataIntelligence[googleplayPaid]?.value;
          googleValueDate = dataIntelligence[googleplayPaid]?.date;
        }
        const objTemp = {
          title: appstoreFree === -1 && googleplayFree === -1 ? 'dbh_top_paid' : 'dbh_top_free',
          icon: '',
          list: [
            { icon: 'Appstore', num: dealRankValue(appleValue), date: appleValueDate || '' },
            { icon: 'vodel', num: dealRankValue(googleValue), date: googleValueDate || '' },
          ],
          goto: 'storeRank',
        };
        intelligenceCardList.push(objTemp);
      } else if (entityType === 'pc') {
        const steamIndex = dataIntelligence.findIndex(
          (item: any) => item.metric === 'steam top sellers',
        );
        const epicIndex = dataIntelligence.findIndex(
          (item: any) => item.metric === 'epic top sellers',
        );
        const steamValue = dataIntelligence[steamIndex]?.value;
        const steamValueDate = dataIntelligence[steamIndex]?.date;
        const epicValue = dataIntelligence[epicIndex]?.value;
        const epicValueDate = dataIntelligence[epicIndex]?.date;
        const objTemp = {
          title: 'dbh_store_topSeller',
          icon: '',
          list: [
            { icon: 'steam', num: dealRankValue(steamValue), date: steamValueDate || '' },
            { icon: 'epic', num: dealRankValue(epicValue), date: epicValueDate || '' },
          ],
          goto: 'storeRank',
        };
        intelligenceCardList.push(objTemp);
      }
    }
  }
  return intelligenceCardList;
};

// 返回组件的挂载状态，如果还没挂载或者已经卸载，返回false；反之，返回true
export const useMountedRef = () => {
  const mountedRef = useRef(false);

  useEffect(() => {
    // 页面加载完调用
    mountedRef.current = true;
    // 页面卸载调用
    return () => {
      mountedRef.current = false;
    };
  });
  return mountedRef;
};

// 获取搜索词高亮正则公共方法
export const getHighLineReg = (inputValue: string) => {
  // 特殊字符，做转义处理
  const strSearch = inputValue.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(`(${strSearch})`, 'gi');
  return regex;
};

// 是否在2个月有效期内
export const isWithinTwoMonths = () =>
  // 临时热更需求，固定增加三个游戏，时效2个月
  // 暂定为永久，后续根据产品定的有效期为准
  true;
// 从2024年12月2日上线开始
// return new Date() <= new Date(2025, 1, 2);

// 搜索词高亮方法
export const getHighLine = (text: string, inputValue: string) =>
  text?.replace(
    getHighLineReg(inputValue),
    (item) => `<span class="search-high-line">${item}</span>`,
  );
